/**
 * Indicates whether translation keys should be displayed instead of localized text.
 */
export let showTranslationKeys: boolean = false;

/**
 * Toggles the global display of translation keys.
 * @param value True to reveal translation keys; false to show localized strings.
 */
export const setShowTranslationKeys = (value: boolean) => {
    showTranslationKeys = value;
};
